// extracted by mini-css-extract-plugin
export default {"modalOverlay":"infoModal_modalOverlay__2ExYD","modalContent":"infoModal_modalContent__p7Dwb","modalClose":"infoModal_modalClose__uNNck"};